const prependZero = (n: number): string => (n < 10 ? `0${n}` : `${n}`);

export const dateToString = (date: Date | null) =>
  !date
    ? ''
    : `${date.getUTCFullYear()}-${prependZero(
        date.getUTCMonth() + 1,
      )}-${prependZero(date.getUTCDate())}`;
